__turbopack_context__.v({
  "container": "lujpra_container",
  "ctaButtons": "lujpra_ctaButtons",
  "section": "lujpra_section",
  "stat": "lujpra_stat",
  "statDivider": "lujpra_statDivider",
  "statLabel": "lujpra_statLabel",
  "statValue": "lujpra_statValue",
  "statsBar": "lujpra_statsBar",
  "subtitle": "lujpra_subtitle",
  "title": "lujpra_title",
});
